module.exports = __webpack_public_path__ + "img/Honduras.e3bd0684.png";